/**
 * Emerging Payments API
 * The public API for Emerging Payments.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PlacementContentRef } from './PlacementContentRef';
import { HttpFile } from '../http/http';

export class Placement {
    /**
    * A globally unique id.
    */
    'id'?: string;
    'content'?: PlacementContentRef;
    'renderContext'?: any;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "content",
            "baseName": "content",
            "type": "PlacementContentRef",
            "format": ""
        },
        {
            "name": "renderContext",
            "baseName": "renderContext",
            "type": "any",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Placement.attributeTypeMap;
    }
    
    public constructor() {
    }
}

